module.exports = __webpack_public_path__ + "static/media/now-trending-banner.c26898e3.png";